import React, { useState, useEffect, useRef } from "react";
import { DatePicker } from "@sainsburys-tech/fable";
import moment from "moment";
import PropTypes from "prop-types";

moment.locale("en-GB");

const today = moment().format("YYYY-MM-DD");

const EnergyChartDatePicker = props => {
  const from = moment(props.from);
  const to = moment(props.to);

  const [startDate, setStartDate] = useState(from.format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(to.format("YYYY-MM-DD"));
  const [fromOpen, setFromOpen] = useState(false);
  const [toOpen, setToOpen] = useState(false);

  useEffect(() => {
    setStartDate(moment(props.from).format("YYYY-MM-DD"));
    setEndDate(moment(props.to).format("YYYY-MM-DD"));
  }, [props.from, props.to]);

  const handleFromChange = (newDate) => {
    if (newDate && moment(newDate, "YYYY-MM-DD").isValid()) {
      setStartDate(newDate);
      setFromOpen(false);
      // Auto-open To picker after From selected
      setToOpen(true);
    }
  };

  const handleToChange = (newDate) => {
    if (newDate && moment(newDate, "YYYY-MM-DD").isValid()) {
      setEndDate(newDate);
      setToOpen(false);
      // Fire chart update when both dates valid
      props.onDateChange(
        moment(startDate, "YYYY-MM-DD"),
        moment(newDate, "YYYY-MM-DD")
      );
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <DatePicker
        label="From"
        value={startDate}
        isOpen={fromOpen}
        onOpen={() => setFromOpen(true)}
        onClose={() => setFromOpen(false)}
        onChange={handleFromChange}
        max={today}
        weekStartDay="monday"
        numberOfMonths={1}
      />
      <span style={{ flexShrink: 0 }}>→</span>
      <DatePicker
        label="To"
        value={endDate}
        isOpen={toOpen}
        onOpen={() => setToOpen(true)}
        onClose={() => setToOpen(false)}
        onChange={handleToChange}
        min={startDate}
        max={today}
        weekStartDay="monday"
        numberOfMonths={1}
      />
    </div>
  );
};

EnergyChartDatePicker.propTypes = {
  onDateChange: PropTypes.func,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired
};

export default EnergyChartDatePicker;
